module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Puzzle-5a3a13077bec600862ed358cfe261823.svg";